import { render, staticRenderFns } from "./ChampionshipNavigation.vue?vue&type=template&id=4f5205b5&scoped=true&"
import script from "./ChampionshipNavigation.vue?vue&type=script&lang=js&"
export * from "./ChampionshipNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipNavigation.vue?vue&type=style&index=0&id=4f5205b5&lang=scss&scoped=true&"
import style1 from "./ChampionshipNavigation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5205b5",
  null
  
)

export default component.exports